import React from "react";
import { Phone, Mail, MapPin } from "lucide-react";
import "./styles/AnnouncementBar.css";

export default function AnnouncementBar() {
  return (
    <div className="announcement-bar">
      <div className="left item">
        <a href="tel:0410339620">
          <Phone size={16} /> +61 410 338 620
        </a>
      </div>

      <div className="center item">
        <a href="mailto:info@ozzieducationgroup.vic.edu.au">
          <Mail size={16} /> info@ozzieducationgroup.vic.edu.au
        </a>
      </div>

      <div className="right item">
        <MapPin size={16} /> Level 3, 341 Queen St, Melbourne VIC 3000
      </div>
    </div>
  );
}
